import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Flex,
  Text,
} from '@chakra-ui/react';

export default function ApprovalTable({ transfers, textColor, onApproval }) {
  
  // ANTISIPASI: Cek apakah transfers berupa array murni, atau masih berbentuk object pagination
  const actualData = Array.isArray(transfers) 
    ? transfers 
    : (transfers?.data && Array.isArray(transfers.data) ? transfers.data : []);

  // Proteksi jika data benar-benar kosong setelah dievaluasi
  if (!actualData || actualData.length === 0) {
    return (
      <Flex justify="center" align="center" py="50px">
        <Text color="gray.500" fontWeight="medium">
          Tidak ada pengajuan pengalihan tiket saat ini. 🎉
        </Text>
      </Flex>
    );
  }

  return (
    <Box overflowX="auto">
      <Table variant="simple" color="gray.500" mb="24px">
        <Thead>
          <Tr>
            <Th color="gray.400">ID Req</Th>
            <Th color="gray.400">Tiket Keluhan</Th>
            <Th color="gray.400">Teknisi Asal</Th>
            <Th color="gray.400">Teknisi Tujuan</Th>
            <Th color="gray.400">Alasan Pengalihan</Th>
            <Th color="gray.400">Status</Th>
            <Th color="gray.400" textAlign="center">Aksi</Th>
          </Tr>
        </Thead>
        <Tbody>
          {actualData.map((item) => {
            // Amankan string status dengan merubahnya ke huruf kecil (lowercase)
            const statusLower = item?.status ? String(item.status).toLowerCase() : 'pending';

            return (
              <Tr key={item.id}>
                {/* ID Request Transfer */}
                <Td fontWeight="bold" color={textColor}>
                  #{item.id}
                </Td>

                {/* Info Tiket yang dialihkan (item.ticket.subject) */}
                <Td maxW="220px">
                  <Text fontWeight="semibold" color={textColor} isTruncated title={item.ticket?.subject}>
                    {item.ticket?.subject || `Tiket #${item.ticket_id || '-'}`}
                  </Text>
                  <Text fontSize="xs" color="gray.400" isTruncated title={item.ticket?.description}>
                    {item.ticket?.description || '-'}
                  </Text>
                </Td>

                {/* Teknisi Pengaju / Asal (item.from_technician.name) */}
                <Td color={textColor}>
                  {item.from_technician?.name || 'Teknisi Tidak Diketahui'}
                </Td>

                {/* Teknisi Tujuan (item.to_technician.name) */}
                <Td color={textColor}>
                  {item.to_technician?.name || 'Teknisi Tidak Diketahui'}
                </Td>

                {/* Alasan */}
                <Td maxW="200px">
                  <Text fontSize="sm" color={textColor} isTruncated title={item.reason}>
                    {item.reason || '-'}
                  </Text>
                </Td>

                {/* Status Badge */}
                <Td>
                  <Badge 
                    colorScheme={statusLower === 'approved' ? 'green' : statusLower === 'rejected' ? 'red' : 'orange'} 
                    variant="solid" 
                    borderRadius="4px"
                  >
                    {statusLower.toUpperCase()}
                  </Badge>
                </Td>

                {/* Aksi hanya muncul jika status masih pending */}
                <Td>
                  {statusLower === 'pending' ? (
                    <Flex justify="center" gap="10px">
                      <Button
                        colorScheme="green"
                        size="sm"
                        borderRadius="8px"
                        onClick={() => onApproval(item.id, 'approve')}
                      >
                        Setujui
                      </Button>
                      <Button
                        colorScheme="red"
                        variant="outline"
                        size="sm"
                        borderRadius="8px"
                        onClick={() => onApproval(item.id, 'reject')}
                      >
                        Tolak
                      </Button>
                    </Flex>
                  ) : (
                    <Text textAlign="center" fontSize="xs" color="gray.400" fontStyle="italic">
                      Selesai
                    </Text>
                  )}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
}